export default __webpack_public_path__ + "static/media/icon-placards.50b86354.svg";